export function importAll(r) {
  return r.keys().map(r);
}